export default ({ email, password }) => {
    const host = process.env.REACT_APP_API_HOST || 'http://localhost:4000';

    return fetch(`${host}/v1/user`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email,
            password,
        }),
    }).then((response) => {
        if (response.ok) return response.json();
        throw new Error('sign up for user failed');
    });
};
